import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import {
  ShipmentLoadDemurrageAndDetentionInfoLoad,
  ShipmentLoadDemurrageAndDetentionInfoSetInitialState,
} from './shipment-load-demurrage-and-detention-info.actions';
import { ShipmentLoadDemurrageAndDetentionInfoState } from './shipment-load-demurrage-and-detention-info.state';
import { ShipmentLoadDemurrageAndDetentionContainer, ShipmentLoadDemurrageAndDetentionSummary } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadDemurrageAndDetentionInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadDemurrageAndDetentionInfoState.getLoaded);
  summary$: Observable<ShipmentLoadDemurrageAndDetentionSummary> = this.store.select(
    ShipmentLoadDemurrageAndDetentionInfoState.getSummary,
  );
  origin$: Observable<ShipmentLoadDemurrageAndDetentionContainer> = this.store.select(
    ShipmentLoadDemurrageAndDetentionInfoState.getOrigin,
  );
  destination$: Observable<ShipmentLoadDemurrageAndDetentionContainer> = this.store.select(
    ShipmentLoadDemurrageAndDetentionInfoState.getDestination,
  );

  constructor(private store: Store) {}

  loadAll(identifier: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadDemurrageAndDetentionInfoLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadDemurrageAndDetentionInfoSetInitialState());
  }
}
